import { useTranslation } from '../presentation/common/useTranslation.js';
import LandingIntro, { PlaceholderText } from './LandingIntro';
import Skeleton from './Skeleton';
import SkeletonDelay from './SkeletonDelay';
import { HERO_CLASSES } from '../data/heroClasses';
import './LandingClasses.css';
import './FlyerDownload.css';

const text = children => <PlaceholderText loading>{children}</PlaceholderText>;

function CommunitySection({ feature, partners = false }) {
  return <section className={`landing-community-section ${partners ? 'landing-community-partners' : ''}`}>
    <div className="landing-community-inner">
      <div className="landing-community-intro">
        <div className="landing-community-emblem"><Skeleton className="w-full aspect-square" style={{ borderRadius: '50%' }} /></div>
        <div><span className="guild-kicker">{text(feature.kicker)}</span><h2>{text(feature.title)}</h2><p>{text(feature.intro)}</p></div>
      </div>
      <div className="landing-community-grid">{feature.points.map((point, index) => <article className="landing-community-item" key={index}>
        <Skeleton className="landing-community-icon" /><div><h3>{text(point.title)}</h3><p>{text(point.body)}</p></div>
      </article>)}</div>
      <div className="landing-community-bottom"><p>{text(feature.closing)}</p><Skeleton className="h-6 w-36" /></div>
    </div>
  </section>;
}

export default function LandingSkeleton() {
  return <SkeletonDelay><LandingSkeletonContent /></SkeletonDelay>;
}

function LandingSkeletonContent() {
  const { t } = useTranslation();
  const c = t('landing', { returnObjects: true });
  return <main className="landing-page landing-skeleton route-skeleton guild-shell min-h-screen bg-[#061018] text-[#f0ede6]"
    data-skeleton="landing" role="status" aria-busy="true" aria-label={t('common.loading')}>
    <LandingIntro loading />
    <div aria-hidden="true">
      <section className="landing-adventure-flow">
        <div className="landing-community-inner">
          <div className="landing-flow-heading"><span className="guild-kicker">{text(t('adventureFlow.kicker'))}</span><h2>{text(t('adventureFlow.title'))}</h2><p>{text(t('adventureFlow.intro'))}</p></div>
          <ol className="landing-flow-steps">{[0, 1, 2].map(index => <li className="landing-flow-step" key={index}>
            <Skeleton className="landing-flow-icon" /><div className="landing-flow-copy"><h3>{text(t(`adventureFlow.steps.${index}.title`))}</h3><p>{text(t(`adventureFlow.steps.${index}.body`))}</p></div>
          </li>)}</ol>
          <section className="flyer-download">
            <Skeleton className="flyer-download-preview" style={{ aspectRatio: '424 / 600' }} />
            <div><span className="guild-kicker">{text(t('flyers.kicker'))}</span><h2>{text(t('flyers.adventurer.title'))}</h2><p>{text(t('flyers.adventurer.body'))}</p><p className="flyer-download-meta">{text(t('flyers.meta'))}</p><div className="flyer-download-actions"><Skeleton className="h-12 w-48" /><Skeleton className="h-5 w-32" /></div></div>
          </section>
        </div>
      </section>
      <section className="landing-classes">
        <header className="landing-classes-heading"><p className="guild-kicker">{text('Goodvale')}</p><h2>{text(c.classesTitle)}</h2><p>{text(c.classesSubtitle)}</p></header>
        <div className="landing-class-picker">{HERO_CLASSES.map(item => {
          const key = item.key || item[0];
          return <div className="landing-skeleton-class-choice" key={key}><Skeleton className="w-full aspect-square" style={{ borderRadius: '50%' }} /><span>{text(t(`register.class_${key.toLowerCase()}`))}</span></div>;
        })}</div>
        <div className="landing-class-stage"><article className="landing-class-panel is-active">
          <Skeleton className="landing-class-scene" />
          <div className="landing-class-content"><p className="landing-class-role">{text(t('classes.roles.SCOUT'))}</p><h3>{text(t('register.class_scout'))}</h3><p className="landing-class-line">{text(t('classes.lines.SCOUT'))}</p><div className="landing-class-perks"><Skeleton className="h-20 w-full" /><Skeleton className="h-20 w-full" /></div></div>
        </article></div>
      </section>
      <CommunitySection feature={c.guildFeature} />
      <CommunitySection feature={c.partnerFeature} partners />
      <section className="landing-karma mx-auto max-w-6xl px-4 py-16 sm:px-6">
        <div className="mb-6"><p className="guild-kicker">{text(t('landing.karma_kicker'))}</p><h2 className="landing-karma-title mt-2 font-serif text-3xl">{text(t('landing.karma_title'))}</h2><p className="landing-karma-intro mt-2 max-w-2xl text-sm">{text(t('landing.karma_intro'))}</p></div>
        <Skeleton className="h-64 w-full" />
      </section>
      <section className="landing-cta-section px-6 py-24 text-center"><div className="mx-auto max-w-3xl"><Skeleton className="h-2 w-40 mx-auto mb-6" /><h2 className="font-serif text-2xl sm:text-4xl leading-snug">{text(c.cta)}</h2><Skeleton className="h-12 w-48 mx-auto mt-9" /></div></section>
    </div>
  </main>;
}
